export enum Theme {
  LIGHT = 'light',
  DARK = 'dark',
}

export interface BrandTokens {
  primary: string
  // Optional secondary brand accent. Clientportal sets it from portal brandColor2;
  // community/preset tokens omit it and fall back to the theme.css `--cp-secondary-*`
  // defaults. Not part of the completeness gate so existing 8-key literals stay valid.
  secondary?: string
  tertiary: string
  background: string
  surface: string
  error: string
  fontColor: string
  sidebar: string
  border: string
}
